import { Component, inject, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmRadioGroupImports } from '@spartan-ng/helm/radio-group';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

export type BcfFormat = '2.1' | '3.0';

@Component({
  selector: 'ocp-export-bcf-dialog',
  imports: [
    FormsModule,
    HlmButtonImports,
    HlmLabelImports,
    HlmRadioGroupImports,
    ThemedIconComponent,
    TranslatePipe,
  ],
  templateUrl: './export-bcf-dialog.component.html',
  styleUrl: './export-bcf-dialog.component.scss',
})
export class ExportBcfDialogComponent {
  private readonly dialogRef = inject<BrnDialogRef<BcfFormat | undefined>>(BrnDialogRef, {
    optional: true,
  });
  private readonly dialogContext = injectBrnDialogContext<{ defaultFormat?: BcfFormat }>({
    optional: true,
  });

  readonly defaultFormat = input<BcfFormat>('3.0');
  readonly selectedFormat = signal<BcfFormat>(
    this.dialogContext?.defaultFormat ?? this.defaultFormat()
  );

  protected onExport(): void {
    this.dialogRef?.close(this.selectedFormat());
  }

  protected onCancel(): void {
    this.dialogRef?.close();
  }
}
